import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FirstAccessService {
    private _mustChangePassword$ = new BehaviorSubject<boolean>(false);

    public readonly mustChangePassword$ = this._mustChangePassword$.asObservable();

    request(): void {
        this._mustChangePassword$.next(true);
    }

    clear(): void {
        this._mustChangePassword$.next(false);
    }
}